var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2447,
    height: 988,
    viewBox: "0 0 2447 988",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 85.95,
    x2: 2438.24,
    y2: 85.95,
    stroke: "url(#paint0_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 160.05,
    x2: 2438.24,
    y2: 160.05,
    stroke: "url(#paint1_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 234.15,
    x2: 2438.24,
    y2: 234.15,
    stroke: "url(#paint2_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 308.25,
    x2: 2438.24,
    y2: 308.25,
    stroke: "url(#paint3_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 382.35,
    x2: 2438.24,
    y2: 382.35,
    stroke: "url(#paint4_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 456.45,
    x2: 2438.24,
    y2: 456.45,
    stroke: "url(#paint5_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 530.55,
    x2: 2438.24,
    y2: 530.55,
    stroke: "url(#paint6_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 604.65,
    x2: 2438.24,
    y2: 604.65,
    stroke: "url(#paint7_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 678.75,
    x2: 2438.24,
    y2: 678.75,
    stroke: "url(#paint8_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 752.85,
    x2: 2438.24,
    y2: 752.85,
    stroke: "url(#paint9_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 826.95,
    x2: 2438.24,
    y2: 826.95,
    stroke: "url(#paint10_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.23,
    y1: 901.05,
    x2: 2438.24,
    y2: 901.05,
    stroke: "url(#paint11_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.850098,
    y1: -2.18557e-8,
    x2: 0.850141,
    y2: 988,
    stroke: "url(#paint12_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.95,
    y1: -2.18557e-8,
    x2: 74.95,
    y2: 988,
    stroke: "url(#paint13_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.05,
    y1: -2.18557e-8,
    x2: 149.05,
    y2: 988,
    stroke: "url(#paint14_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.15,
    y1: -2.18557e-8,
    x2: 223.15,
    y2: 988,
    stroke: "url(#paint15_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.25,
    y1: -2.18557e-8,
    x2: 297.25,
    y2: 988,
    stroke: "url(#paint16_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.35,
    y1: -2.18557e-8,
    x2: 371.35,
    y2: 988,
    stroke: "url(#paint17_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 445.45,
    y1: -2.18557e-8,
    x2: 445.45,
    y2: 988,
    stroke: "url(#paint18_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 519.55,
    y1: -2.18557e-8,
    x2: 519.55,
    y2: 988,
    stroke: "url(#paint19_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593.65,
    y1: -2.18557e-8,
    x2: 593.65,
    y2: 988,
    stroke: "url(#paint20_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.75,
    y1: -2.18557e-8,
    x2: 667.75,
    y2: 988,
    stroke: "url(#paint21_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 741.85,
    y1: -2.18557e-8,
    x2: 741.85,
    y2: 988,
    stroke: "url(#paint22_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 815.95,
    y1: -2.18557e-8,
    x2: 815.95,
    y2: 988,
    stroke: "url(#paint23_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 890.05,
    y1: -2.18557e-8,
    x2: 890.05,
    y2: 988,
    stroke: "url(#paint24_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 964.15,
    y1: -2.18557e-8,
    x2: 964.15,
    y2: 988,
    stroke: "url(#paint25_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1038.25,
    y1: -2.18557e-8,
    x2: 1038.25,
    y2: 988,
    stroke: "url(#paint26_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1112.35,
    y1: -2.18557e-8,
    x2: 1112.35,
    y2: 988,
    stroke: "url(#paint27_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1186.45,
    y1: -2.18557e-8,
    x2: 1186.45,
    y2: 988,
    stroke: "url(#paint28_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260.55,
    y1: -2.18557e-8,
    x2: 1260.55,
    y2: 988,
    stroke: "url(#paint29_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1334.65,
    y1: -2.18557e-8,
    x2: 1334.65,
    y2: 988,
    stroke: "url(#paint30_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1408.75,
    y1: -2.18557e-8,
    x2: 1408.75,
    y2: 988,
    stroke: "url(#paint31_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1482.85,
    y1: -2.18557e-8,
    x2: 1482.85,
    y2: 988,
    stroke: "url(#paint32_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1556.95,
    y1: -2.18557e-8,
    x2: 1556.95,
    y2: 988,
    stroke: "url(#paint33_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1631.05,
    y1: -2.18557e-8,
    x2: 1631.05,
    y2: 988,
    stroke: "url(#paint34_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1705.15,
    y1: -2.18557e-8,
    x2: 1705.15,
    y2: 988,
    stroke: "url(#paint35_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1779.25,
    y1: -2.18557e-8,
    x2: 1779.25,
    y2: 988,
    stroke: "url(#paint36_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1853.35,
    y1: -2.18557e-8,
    x2: 1853.35,
    y2: 988,
    stroke: "url(#paint37_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1927.45,
    y1: -2.18557e-8,
    x2: 1927.45,
    y2: 988,
    stroke: "url(#paint38_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2001.55,
    y1: -2.18557e-8,
    x2: 2001.55,
    y2: 988,
    stroke: "url(#paint39_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2075.65,
    y1: -2.18557e-8,
    x2: 2075.65,
    y2: 988,
    stroke: "url(#paint40_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2149.75,
    y1: -2.18557e-8,
    x2: 2149.75,
    y2: 988,
    stroke: "url(#paint41_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2223.85,
    y1: -2.18557e-8,
    x2: 2223.85,
    y2: 988,
    stroke: "url(#paint42_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2297.95,
    y1: -2.18557e-8,
    x2: 2297.95,
    y2: 988,
    stroke: "url(#paint43_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2372.05,
    y1: -2.18557e-8,
    x2: 2372.05,
    y2: 988,
    stroke: "url(#paint44_linear_29_483)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2446.15,
    y1: -2.18557e-8,
    x2: 2446.15,
    y2: 988,
    stroke: "url(#paint45_linear_29_483)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_483",
    x1: 10.23,
    y1: 86.95,
    x2: 2438.24,
    y2: 86.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_483",
    x1: 10.23,
    y1: 161.05,
    x2: 2438.24,
    y2: 161.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_483",
    x1: 10.23,
    y1: 235.15,
    x2: 2438.24,
    y2: 235.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29_483",
    x1: 10.23,
    y1: 309.25,
    x2: 2438.24,
    y2: 309.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29_483",
    x1: 10.23,
    y1: 383.35,
    x2: 2438.24,
    y2: 383.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_29_483",
    x1: 10.23,
    y1: 457.45,
    x2: 2438.24,
    y2: 457.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_29_483",
    x1: 10.23,
    y1: 531.55,
    x2: 2438.24,
    y2: 531.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_29_483",
    x1: 10.23,
    y1: 605.65,
    x2: 2438.24,
    y2: 605.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_29_483",
    x1: 10.23,
    y1: 679.75,
    x2: 2438.24,
    y2: 679.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_29_483",
    x1: 10.23,
    y1: 753.85,
    x2: 2438.24,
    y2: 753.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_29_483",
    x1: 10.23,
    y1: 827.95,
    x2: 2438.24,
    y2: 827.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_29_483",
    x1: 10.23,
    y1: 902.05,
    x2: 2438.24,
    y2: 902.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_29_483",
    x1: -0.149902,
    y1: 2.18557e-8,
    x2: -0.149859,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_29_483",
    x1: 73.95,
    y1: 2.18557e-8,
    x2: 73.95,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_29_483",
    x1: 148.05,
    y1: 2.18557e-8,
    x2: 148.05,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_29_483",
    x1: 222.15,
    y1: 2.18557e-8,
    x2: 222.15,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_29_483",
    x1: 296.25,
    y1: 2.18557e-8,
    x2: 296.25,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_29_483",
    x1: 370.35,
    y1: 2.18557e-8,
    x2: 370.35,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_29_483",
    x1: 444.45,
    y1: 2.18557e-8,
    x2: 444.45,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_29_483",
    x1: 518.55,
    y1: 2.18557e-8,
    x2: 518.55,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_29_483",
    x1: 592.65,
    y1: 2.18557e-8,
    x2: 592.65,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_29_483",
    x1: 666.75,
    y1: 2.18557e-8,
    x2: 666.75,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_29_483",
    x1: 740.85,
    y1: 2.18557e-8,
    x2: 740.85,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_29_483",
    x1: 814.95,
    y1: 2.18557e-8,
    x2: 814.95,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_29_483",
    x1: 889.05,
    y1: 2.18557e-8,
    x2: 889.05,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_29_483",
    x1: 963.15,
    y1: 2.18557e-8,
    x2: 963.15,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_29_483",
    x1: 1037.25,
    y1: 2.18557e-8,
    x2: 1037.25,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_29_483",
    x1: 1111.35,
    y1: 2.18557e-8,
    x2: 1111.35,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_29_483",
    x1: 1185.45,
    y1: 2.18557e-8,
    x2: 1185.45,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_29_483",
    x1: 1259.55,
    y1: 2.18557e-8,
    x2: 1259.55,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_29_483",
    x1: 1333.65,
    y1: 2.18557e-8,
    x2: 1333.65,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_29_483",
    x1: 1407.75,
    y1: 2.18557e-8,
    x2: 1407.75,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_29_483",
    x1: 1481.85,
    y1: 2.18557e-8,
    x2: 1481.85,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_29_483",
    x1: 1555.95,
    y1: 2.18557e-8,
    x2: 1555.95,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_29_483",
    x1: 1630.05,
    y1: 2.18557e-8,
    x2: 1630.05,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_29_483",
    x1: 1704.15,
    y1: 2.18557e-8,
    x2: 1704.15,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_29_483",
    x1: 1778.25,
    y1: 2.18557e-8,
    x2: 1778.25,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_29_483",
    x1: 1852.35,
    y1: 2.18557e-8,
    x2: 1852.35,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_29_483",
    x1: 1926.45,
    y1: 2.18557e-8,
    x2: 1926.45,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_29_483",
    x1: 2000.55,
    y1: 2.18557e-8,
    x2: 2000.55,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_29_483",
    x1: 2074.65,
    y1: 2.18557e-8,
    x2: 2074.65,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_29_483",
    x1: 2148.75,
    y1: 2.18557e-8,
    x2: 2148.75,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_29_483",
    x1: 2222.85,
    y1: 2.18557e-8,
    x2: 2222.85,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_29_483",
    x1: 2296.95,
    y1: 2.18557e-8,
    x2: 2296.95,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_29_483",
    x1: 2371.05,
    y1: 2.18557e-8,
    x2: 2371.05,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_29_483",
    x1: 2445.15,
    y1: 2.18557e-8,
    x2: 2445.15,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownbg);
export default __webpack_public_path__ + "static/media/dropdownbg.08c74dcb9cbec2f81cb7f0d4f598acd7.svg";
export { ForwardRef as ReactComponent };